import type { SupplyClass } from '@wodi/domain';

// How a stock item may leave the pharmacy (dispensing plan §2.3, §5.3), in words.

export const SUPPLY_CLASS_LABELS: Record<SupplyClass, string> = {
  prescription_only: 'Prescription only',
  over_the_counter: 'Over the counter',
};

/** What each class means at the counter, as the sale rules enforce it (sale-rules.ts). */
export const SUPPLY_CLASS_DESCRIPTIONS: Record<SupplyClass, string> = {
  prescription_only:
    'Dispensed against a prescription. At the counter, sold only to an identified patient with an outside prescription.',
  over_the_counter: 'Can be sold at the counter without a patient or a prescription.',
};
